module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9r7r4r-1305f39e4633237c09eebf87c9e14181.svg";